var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreativityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5004 39.5V2C46.0713 2.00074 52.5267 3.72807 58.22 7.00897C63.9132 10.2899 68.6445 15.0091 71.9397 20.6941C75.235 26.379 76.9787 32.83 76.996 39.401C77.0134 45.9719 75.3038 52.432 72.0386 58.1343C68.7734 63.8365 64.0672 68.5808 58.3914 71.8917C52.7155 75.2026 46.2693 76.964 39.6985 76.9994C33.1276 77.0349 26.6628 75.3432 20.9516 72.0937C15.2403 68.8442 10.4832 64.1511 7.15663 58.4844M71.9613 20.75L7.03945 58.25M2.62538 46.375C2.19905 44.1084 1.98977 41.8063 2.00038 39.5C1.99545 31.7445 4.39771 24.1786 8.87568 17.8465C13.3536 11.5144 19.6865 6.72821 27.0004 4.14844V32.2734L2.62538 46.375Z",
    stroke: "url(#paint0_linear_554_1429)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_1429",
    x1: 39.4981,
    y1: 2,
    x2: 39.4981,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EAFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4063B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704BA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativityIcon);
export default __webpack_public_path__ + "static/media/creativity_icon.6509c6b425708848d58ff843fed5193c.svg";
export { ForwardRef as ReactComponent };